import { render, staticRenderFns } from "./Timezone.vue?vue&type=template&id=a5539d8a"
import script from "./Timezone.vue?vue&type=script&lang=js"
export * from "./Timezone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports